var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.05 93.38",
    style: {
      enableBackground: "new 0 0 90.05 93.38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.6418,
    y1: 8.3568,
    x2: 45.6418,
    y2: 87.3869
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.23,16.22v62.84h68.82V16.22H11.23z M32.18,74.57H15.72V64.1h16.46V74.57z M32.18,59.61H15.72V49.14h16.46 V59.61z M32.18,44.65H15.72V34.18h16.46V44.65z M54.62,74.57H36.67V64.1h17.95V74.57z M54.62,59.61H36.67V49.14h17.95V59.61z  M54.62,44.65H36.67V34.18h17.95V44.65z M75.56,74.57H59.11V64.1h16.46V74.57z M75.56,59.61H59.11V49.14h16.46V59.61z M75.56,44.65 H59.11V34.18h16.46V44.65z M75.56,29.69H15.72v-8.98h59.84V29.69z M75.56,29.69"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHru);
export default __webpack_public_path__ + "static/media/HRU.8d2777fd.svg";
export { ForwardRef as ReactComponent };